import React from 'react';
import { View, StyleSheet, ScrollView, Platform } from 'react-native';
import { webColors, webSpacing } from '../../constants/webStyles';
import WebNavbar from './WebNavbar';
import WebFooter from './WebFooter';
import { useIsMobile } from '../../hooks/useIsMobile';

const WebLayout = ({
  children,
  showNavbar = true,
  showFooter = true,
  navbarVariant = 'default', // 'default' | 'auth' | 'transparent'
  containerStyle,
  scrollable = true,
  maxWidth = webSpacing.containerMaxWidth,
}) => {
  const isMobile = useIsMobile();

  if (Platform.OS !== 'web') {
    return children;
  }

  const ContentWrapper = scrollable ? ScrollView : View;
  const contentProps = scrollable
    ? { contentContainerStyle: styles.scrollContent, showsVerticalScrollIndicator: false }
    : { style: styles.content };

  return (
    <View style={styles.layout}>
      {showNavbar && <WebNavbar variant={navbarVariant} />}
      <ContentWrapper {...contentProps}>
        <View style={[
          styles.container,
          isMobile && styles.containerMobile,
          { maxWidth },
          containerStyle
        ]}>
          {children}
        </View>
        {showFooter && <WebFooter />}
      </ContentWrapper>
    </View>
  );
};

const styles = StyleSheet.create({
  layout: {
    flex: 1,
    backgroundColor: webColors.background,
    minHeight: '100vh',
  },
  scrollContent: {
    flexGrow: 1,
  },
  content: {
    flex: 1,
  },
  container: {
    width: '100%',
    marginHorizontal: 'auto',
    paddingHorizontal: webSpacing.containerPadding,
    paddingVertical: 32,
  },
  containerMobile: {
    paddingHorizontal: 16,
    paddingVertical: 20,
  },
});

export default WebLayout;
